import ApiService from './api-service'

class User extends ApiService {
    constructor() {
        super()

        // this.get = null
        // this.post = null
        // this.put = null
        this.delete = null
    }

    clear() {
      return super.clear('/profile')
    }

    get(options) {
      return super.get(`profile`, options)
    }

    async update(payload, options) {
      return super.put(`profile`, payload, options)
    }

    getPrivacySettings(options) {
      return super.get(`profile/settings/privacy`, options)
    }

    setPrivacySettings(payload, options) {
      return super.put(`profile/settings/privacy`, payload, options)
    }

    getGroupPrivacySettings(idGroup, options) {
      return super.get(`profile/privacy/group/${idGroup}`, options)
    }

    setGroupPrivacySettings(idGroup, payload, options) {
      return super.put(`profile/privacy/group/${idGroup}`, payload, options)
    }

    getNotificationSettings(options) {
      return super.get(`profile/settings/notifications`, options)
    }

    setNotificationSettings(payload, options) {
      return super.put(`profile/settings/notifications`, payload, options)
    }
}

const _User = new User()
export default _User
